var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "myskov-newsletter" }, [
    _c(
      "div",
      { staticClass: "profile-block" },
      [
        _c("div", { staticClass: "profile-block__heading" }, [
          _c("h3", {
            domProps: { textContent: _vm._s(_vm.translations.title) }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "profile-block__text" }, [
          _c("p", {
            domProps: { textContent: _vm._s(_vm.translations.description) }
          })
        ]),
        _vm._v(" "),
        _vm.customer.subscribeNewsletter !== null
          ? _c("checkbox", {
              attrs: {
                name: _vm.translations.input_checkbox,
                value: _vm.customer.subscribeNewsletter
              },
              on: { checked: _vm.changeNewsletterValue }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.success
          ? _c("msg-block", [
              _c("p", {
                domProps: { textContent: _vm._s(_vm.translations.success_msg) }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.error
          ? _c("msg-block", { attrs: { type: "error" } }, [
              _c("p", [
                _c("b", { domProps: { textContent: _vm._s(_vm.error) } })
              ])
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bfd19b64", { render: render, staticRenderFns: staticRenderFns })
  }
}